export default {
    data() {
      return {
        pt: {
          bt_follow: 'Seguir',
          bt_following: 'Seguindo',
 
          //--- Menu
          menu_title_1: 'Músicas',
          menu_title_2: 'Álbuns',
          menu_title_3: 'Sobre',
          menu_title_4: 'Playlists',
          menu_title_5: 'Shows',
          menu_title_6: 'Contato',
 
          //---- Check Now ----
          check_now: 'Confira Agora',
          sub_check: 'Ver',
            
          //---- last albums ----
          last_album: 'Últimos Álbuns',

          //---- Page Contact ----
          title_contact: 'CONTATO',
          title_contact_me: 'Entre em Contato',
          bt_contact_me: 'Mande um email',
 
          title_kit: 'Kit Técnico',
          title_kit_press: 'Kit Imprensa',
          sub_title_kit: 'Faça download abaixo',
 
          file_protected_title: 'Arquivo Protegido',
          file_protected_title_input: 'Insira a senha para continuar',
          file_protected_bt: 'Verificar',
          protected_bt_open: 'Abrir',
          protected_bt_close: 'Fechar',
 
          verifyPassword: 'Senha incorreta!',        
 
          //---- show_more ----
          open: 'Ler mais',
          close: 'Fechar',

          // ---- Contractors ----
          title_contractors: 'Contratantes',

          //---- Page Schedule -----
          title_show_schedule: 'Calendário de Shows',
          info_show: 'Nenhum show disponível',
          ticket: 'Ingressos',
 
        },
 
        en: {
          bt_follow: 'Follow',
          bt_following: 'Following',
 
          //--- Menu
          menu_title_1: 'Songs',
          menu_title_2: 'Albums',
          menu_title_3: 'About',
          menu_title_4: 'Playlists',
          menu_title_5: 'Shows',
          menu_title_6: 'Contact',
 
          //---- Check Now ----
          check_now: 'Check It Now',
          sub_check: 'Show',
            
          //---- last albums ----
          last_album: 'Latest Albums',

          //---- Page Contact ----
          title_contact: 'CONTACT',
          title_contact_me: 'Get in Touch',
          bt_contact_me: 'Send email',
 
          title_kit: 'Technical Kit',
          title_kit_press: 'Press Kit',
          sub_title_kit: 'Do it download below',
 
          file_protected_title: 'File Protected',
          file_protected_title_input: 'Enter password to continue',
          file_protected_bt: 'Check',
          protected_bt_open: 'Open',
          protected_bt_close: 'Close',
 
          verifyPassword: 'Incorrect password!',
 
          //---- show_more ----
          open: 'Show more',
          close: 'Close',

          // ---- Contractors ----
          title_contractors: 'Contractors',

          //---- Page Schedule -----
          title_show_schedule: 'Show schedule',
          info_show: 'There are no shows available',
          ticket: 'Tickets',
 
        },
        
        it: {
          bt_follow: 'Segui',
          bt_following: 'Seguendo',
 
          //--- Menu
          menu_title_1: 'Canzoni',
          menu_title_2: 'Album',
          menu_title_3: 'Chi siamo',
          menu_title_4: 'Playlist',
          menu_title_5: 'Spettacoli',
          menu_title_6: 'Contatto',
 
          //---- Check Now ----
          check_now: 'Scopri ora',
          sub_check: 'Vedi',
            
          //---- last albums ----
          last_album: 'Ultimi Album',

          //---- Page Contact ----
          title_contact: 'CONTATTO',
          title_contact_me: 'Mettiti in contatto',
          bt_contact_me: 'Invia email',
 
          title_kit: 'Kit Tecnico',
          title_kit_press: 'Kit Stampa',
          sub_title_kit: 'Scarica qui sotto',
 
          file_protected_title: 'File Protetto',
          file_protected_title_input: 'Inserisci la password per continuare',
          file_protected_bt: 'Verifica',
          protected_bt_open: 'Apri',
          protected_bt_close: 'Chiudi',
 
          verifyPassword: 'Password errata!',
 
          //---- show_more ----
          open: 'Leggi di più',
          close: 'Chiudi',

          // ---- Contractors ----
          title_contractors: 'Promotori',

          //---- Page Schedule -----
          title_show_schedule: 'Calendario degli spettacoli',
          info_show: 'Nessuno spettacolo disponibile',
          ticket: 'Biglietti',
 
        },
      }
    }
  }
